import { CalculateStore } from "../../../../stores/calculateStore";
import RiskName from "../riskName/riskName";
import { RisksId } from "../../../../helpers/risk";
import DropDown from "../../../sharedComponents/dropDown/dropDown";
import { inject, observer } from "mobx-react";
import React from "react";
import { SafeSeniorCountDropDown } from "../../../../helpers/safeSenior";
import InsuranceSumFixed from "../insuranceSumFixed/InsuranceSumFixed";
import { ProposalStore } from "../../../../stores/proposalStore";
import { displayAdditionalRiskForm } from "../../../../helpers/risksNetwork";

interface SafeSeniorProps {
  calculateStore?: CalculateStore;
  proposalStore?: ProposalStore;
}

export function SafeSenior(props: SafeSeniorProps) {
  const calculateStore = props.calculateStore!;
  const proposalStore = props.proposalStore!;
  const safeSenior = calculateStore.additionalInsurances.safeSenior;
  const displayForm = displayAdditionalRiskForm(calculateStore.additionalInsurances.safeSenior);

  return (
    <div className="section safe-senior">
      <RiskName
        checkboxOnChange={(event) => {
          calculateStore.setAdditionalInsuranceFieldChecked(RisksId.safeSenior, event.target.checked);
        }}
        riskId={RisksId.safeSenior}
        displayIcon={true}
      />
      {displayForm && (
        <div className="safe-senior-wrapper">
          <div className="risk-value">
            <DropDown
              onChange={(value) => {
                calculateStore.setSafeSeniorCount(value);
                proposalStore.safeSenior.setNumberOfSeniors(value);
              }}
              value={safeSenior.safeSeniorCount}
              items={SafeSeniorCountDropDown.dropDown}
              topLabel={SafeSeniorCountDropDown.label}
            />
            <InsuranceSumFixed
              riskId={RisksId.safeSenior}
              value={"3 000 zł oraz świadczenia w OWU"} />
          </div>
        </div>
      )}
    </div>
  );
}

export default inject("calculateStore", "proposalStore")(observer(SafeSenior));
